import { render, staticRenderFns } from "./remitInfo.vue?vue&type=template&id=7459514d"
import script from "./remitInfo.vue?vue&type=script&lang=js"
export * from "./remitInfo.vue?vue&type=script&lang=js"
import style0 from "./remitInfo.vue?vue&type=style&index=0&id=7459514d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports